import { useMemo } from 'react';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Columns from 'components/shared/Layout/Columns';

export type KampusBadgeProps = {
  size?: 'small' | 'medium' | 'large';
  linkTo?: string;
  showLogotype?: boolean;
  logotypeContent?: string;
  LogoSvg: React.ComponentType<{
    width?: number | string;
    height?: number | string;
  }>;
};

export default function KampusBadge({
  linkTo,
  LogoSvg,
  size = 'medium',
  showLogotype = false,
  logotypeContent = 'Kampus',
}: KampusBadgeProps) {
  const logoSizeAsRem = useMemo(() => {
    switch (size) {
      case 'small':
        return '2rem';
      case 'medium':
        return '2.5rem';
      case 'large':
        return '4rem';
      default:
        return undefined;
    }
  }, [size]);

  return (
    <Columns sx={{ alignItems: 'center' }}>
      {linkTo ? (
        <Link display="flex" href={linkTo}>
          <LogoSvg width={logoSizeAsRem} height={logoSizeAsRem} />
        </Link>
      ) : (
        <Box display="flex">
          <LogoSvg width={logoSizeAsRem} height={logoSizeAsRem} />
        </Box>
      )}
      {showLogotype && (
        <Box
          sx={{
            borderLeft: (theme) => `1px solid ${theme.palette.grey[500]}`,
            px: 2,
            ml: 2,
            py: 0.2,
          }}
        >
          <Typography variant="kampus" color="white">
            {logotypeContent}
          </Typography>
        </Box>
      )}
    </Columns>
  );
}
